module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "card-mastercard.487f97ac.svg";